// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';
import { createStructuredSelector } from 'reselect';

// Selectors
import { activeModalIdSelector } from './activeModalSelector';

// Components
import NonRouteModalManager from './NonRouteModalManager';
import ShareModal from '../../workspace/header/currentBoardHeader/sharing/modal/ShareModal';
import LoadableShortcutsModal from '../../workspace/shortcuts/modal/LoadableShortcutsModal';
import AiAssistantReportFeedbackModal from '../../workspace/toolbar/components/elementTools/aiAssistantTool/popup/AiAssistantReportFeedbackModal';
import TableAnnouncementModal from '../../element/table/modal/TableAnnouncementModal';

// Constants
import { ModalIds } from './modalConstants';

const getModal = (activeModalId, props) => {
    switch (activeModalId) {
        case ModalIds.SHORTCUTS:
            return <LoadableShortcutsModal />;
        case ModalIds.SHARE:
            return <ShareModal {...props} />;
        case ModalIds.AI_REPORT_FEEDBACK:
            return <AiAssistantReportFeedbackModal {...props} />;
        case ModalIds.TABLE_ANNOUNCEMENT:
            return <TableAnnouncementModal {...props} />;
        default:
            return null;
    }
};

// Use the modal manager to attach the close events
const getWrappedModal = (activeModalId, props) => {
    if (!activeModalId) return null;

    const modal = getModal(activeModalId, props);

    if (!modal) return null;

    return (
        <NonRouteModalManager key={activeModalId} {...props}>
            {modal}
        </NonRouteModalManager>
    );
};

const mapStateToProps = createStructuredSelector({
    activeModalId: activeModalIdSelector,
});

const WorkspaceModalManager = (props) => {
    const { activeModalId } = props;

    const modal = getWrappedModal(activeModalId, props);

    return (
        <CSSTransitionGroup
            transitionName="fade-grow"
            transitionAppear
            transitionEnterTimeout={600}
            transitionLeaveTimeout={600}
            transitionAppearTimeout={600}
        >
            {modal}
        </CSSTransitionGroup>
    );
};

WorkspaceModalManager.propTypes = {
    activeModalId: PropTypes.string,
    dispatchModalClose: PropTypes.func,
};

export default connect(mapStateToProps)(WorkspaceModalManager);
